import classes from './Mark.module.scss'

export interface Props {
  children: string
}

const Mark = ({
  children
}: Props) =>
  <mark className={classes.Mark}>
    {children}
  </mark>

export default Mark
